import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import Swal from "sweetalert2/dist/sweetalert2.js";
import { api } from './api';

// Los campos que la copia dejó vacíos: un subformulario (o campo tipo formato) cuyo hijo no entró
// en la copia. Aquí se les elige el formato y el servidor los RECREA, porque la app solo arma la
// asociación y la pregunta espejo al crear el campo, nunca al editarlo (ver Duplicator::PendingLinker).
const PendingFields = ({ executionId, onLinked }) => {
    const [rows, setRows] = useState(null);
    const [formats, setFormats] = useState([]);
    const [choice, setChoice] = useState({});
    const [busy, setBusy] = useState(null);
    const [error, setError] = useState(null);

    const load = () => api.pending(executionId).then((r) => {
        if (!r.ok) return setError(r.error);
        setRows(r.pending || []);
        setFormats((r.formats || []).map((f) => ({ value: f.id, label: f.name })));
    });

    useEffect(() => { load(); }, [executionId]);

    const link = (row) => {
        const elegido = choice[row.question_id];
        if (!elegido) return;
        setBusy(row.question_id); setError(null);
        api.linkPending(executionId, { question_id: row.question_id, format_relation_id: elegido.value })
            .then((r) => {
                setBusy(null);
                if (!r.ok) return setError(r.error);
                Swal.fire({ type: "success", title: "Campo vinculado",
                    text: `«${r.linked.question}» ahora usa «${r.linked.formato}».`, timer: 2200, showConfirmButton: false });
                load();
                if (onLinked) onLinked();
            });
    };

    if (rows === null) return null;
    if (rows.length === 0) return null;

    return (
        <div className="sd-card" style={{ borderColor: "#fde68a", background: "#fffdf5" }}>
            <h3 className="sd-card__title"><i className="fas fa-pen" style={{ color: "#d97706" }}></i> {rows.length} campo(s) por llenar</h3>
            <p className="sd-card__hint">
                Estos campos quedaron sin formato relacionado porque ese formato no entró en la copia (una decisión «pendiente»,
                o una plantilla vieja, que nunca se copia). Elígele a cada uno su formato y se arregla aquí mismo: el campo se
                vuelve a crear en el destino con su asociación y su pregunta espejo, que es lo que la app hace al crearlo a mano.
                <br />
                <b>Ojo:</b> después de arreglar un campo, «Deshacer la copia» ya no va a poder quitarla del todo —queda trabajo del
                cliente encima— y solo podrá apagarla. Si piensas deshacerla, hazlo antes.
            </p>
            {error && <div className="rk-alert" style={{ marginBottom: 12 }}><i className="fas fa-exclamation-circle"></i> {error}</div>}
            {rows.map((row) => (
                <div key={row.question_id} className="sd-decision is-pending">
                    <div>
                        <div className="sd-decision__name">
                            <span className="sd-badge sd-badge--muted">{row.question_type === "answer_subform" ? "Subformulario" : "Campo tipo formato"}</span>
                            {row.campo}
                        </div>
                        <div className="sd-decision__reason">En el formato copiado «{row.formato}». En el original apuntaba a {row.apuntaba_a ? `el formato #${row.apuntaba_a}` : "otro formato"}, que no entró en la copia.</div>
                    </div>
                    <div>
                        <Select classNamePrefix="select" options={formats} placeholder="Elegir formato…"
                            value={choice[row.question_id] || null}
                            onChange={(o) => setChoice({ ...choice, [row.question_id]: o })} />
                        <button type="button" className="rk-btn rk-btn--primary" style={{ marginTop: 8, width: "100%" }}
                            disabled={!choice[row.question_id] || busy === row.question_id}
                            onClick={() => link(row)}>
                            {busy === row.question_id ? <i className="fas fa-spinner fa-spin"></i> : <i className="fas fa-link"></i>} Vincular
                        </button>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default PendingFields;
